module.exports = __webpack_public_path__ + "static/media/nf.7d9224c8.jpeg";